import { useSyncExternalStore } from 'react'

// Whether an agent turn is streaming on this page right now. The chat page
// writes it from its session's isStreaming; UpdateBanner reads it, so a new
// version is never offered (or loaded) in the middle of an answer. The banner
// is mounted above the providers, so it cannot read the chat context itself.

let turnActive = false
const listeners = new Set<() => void>()

export function setTurnActive(active: boolean): void {
  if (turnActive === active) return
  turnActive = active
  for (const listener of listeners) listener()
}

export function isTurnActive(): boolean {
  return turnActive
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}

export function useTurnActive(): boolean {
  return useSyncExternalStore(subscribe, isTurnActive, isTurnActive)
}
